import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'

import {
  computeHouseAvailabilitiesToInputDto,
  computeHouseAvailabilityGlobalToInputDto,
} from '../../helpers/compute-house-availability-global'
import {
  HouseAvailabilityGlobalOrIndividualDto,
  HouseAvailabilityGlobalOrIndividualManyDto,
} from '../../../../../../../lib/graphql'
import { Button } from '../../../../../../../shadcn/components/ui/button'
import { Spinner } from '../../../../../../atoms'
import {
  BigCalendarModalGlobalFormProps,
  useBigCalencarFormContext,
} from '../../../shared/calendar/utils/use-big-calendar-form'

export type BigCalendarModalFooterGlobalProps = {
  onUpsertHouseAvailability: {
    isLoading: boolean
    mutate: (inputDto: HouseAvailabilityGlobalOrIndividualDto) => void
  }
  onUpsertManyHouseAvailabilities: {
    isLoading: boolean
    mutate: (inputDto: HouseAvailabilityGlobalOrIndividualManyDto) => void
  }
  isFormDisabled: boolean
}
export const BigCalendarModalFooterGlobal = ({
  onUpsertHouseAvailability: { isLoading, mutate },
  onUpsertManyHouseAvailabilities: {
    isLoading: isLoadingMany,
    mutate: mutateMany,
  },
  isFormDisabled,
}: BigCalendarModalFooterGlobalProps) => {
  const intl = useIntl()
  const { handleOnModalClose, modalFormProps: modalState } =
    useBigCalencarFormContext()

  if (!modalState?.formValues) {
    return (
      <div className='flex w-full justify-end gap-4'>
        <Button
          onClick={handleOnModalClose}
          disabled={isLoading}
          className='min-w-[120px]'
        >
          {intl.formatMessage({
            defaultMessage: 'Annuler',
            id: 'ui.BigCalendarModalFooterGlobal.cancel',
          })}
        </Button>
      </div>
    )
  }

  const handleOnClose = (formData?: BigCalendarModalGlobalFormProps) => {
    reset(formData)

    handleOnModalClose()
  }

  const {
    handleSubmit,
    formState: { isValid, isDirty },
    reset,
  } = useFormContext<BigCalendarModalGlobalFormProps>()

  const onSubmitCell = (formData: BigCalendarModalGlobalFormProps) => {
    const inputDto = computeHouseAvailabilityGlobalToInputDto(formData)

    mutate(inputDto)

    handleOnClose(formData)
  }

  const onSubmitSlots = (formData: BigCalendarModalGlobalFormProps) => {
    if (formData.type !== 'slots') {
      return
    }

    const inputDto = computeHouseAvailabilitiesToInputDto(formData)

    mutateMany(inputDto)

    handleOnClose(formData)
  }

  const onSubmit = (formData: BigCalendarModalGlobalFormProps) => {
    const { type } = modalState

    if (type === 'cell') {
      return onSubmitCell(formData)
    }

    if (type === 'slots') {
      return onSubmitSlots(formData)
    }
  }

  return (
    <div className='flex w-full justify-end gap-4'>
      <Button
        onClick={() => handleOnClose()}
        disabled={isLoading || isLoadingMany || isFormDisabled}
        className='min-w-[120px]'
      >
        {intl.formatMessage({
          defaultMessage: 'Annuler',
          id: 'ui.BigCalendarModalFooterGlobal.cancel',
        })}
      </Button>

      <Button
        type='submit'
        onClick={handleSubmit(onSubmit)}
        disabled={
          !isValid || !isDirty || isLoading || isLoadingMany || isFormDisabled
        }
        className='min-w-[120px]'
      >
        {isLoading ? (
          <Spinner height={20} width={20} />
        ) : (
          intl.formatMessage({
            defaultMessage: 'Enregistrer',
            id: 'ui.BigCalendarModalFooterGlobal.save',
          })
        )}
      </Button>
    </div>
  )
}
